module.exports = __webpack_public_path__ + "img/marker-red-48.562aecdc.png";